import BaseProxy from "../../base-proxy";
import QueryStringHelper from "@/utilities/query-string-helper";

export default class CheckExistingEmailProxy {
  async checkEmail(input = {}) {
    const baseProxy = new BaseProxy();
    const backendUrl = await baseProxy.getBackendUrl();
    const queryStringHelper = new QueryStringHelper();
    const query = queryStringHelper.buildQuery({ ...input });
    const endpointUrl = `${backendUrl}/v2/sleek-site-onboarding/check-existing-email${query}`;

    return baseProxy.getAuthenticatedData(endpointUrl, null);
  }
}
